import { Component, OnInit, ViewChild } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import {FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import {Observer, Observable} from 'rxjs';
import {ValidationErrors} from '@angular/forms';
import {DeptService} from "@ecip/service";
import {CacheService} from "@delon/cache";

@Component({
  selector: 'app-user-dept-edit',
  templateUrl: './edit.component.html',
})
export class UserDeptEditComponent implements OnInit {
  record: any = {};
  i: any;
  isRoot: boolean;
  form: FormGroup;
  parent;
  stateList = this.cacheService.get(`api/dict/type/enableState`);

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    private fb: FormBuilder,
    public deptService: DeptService,
    private cacheService: CacheService
  ) {

  }

  ngOnInit(): void {
    let nodeLevel;
    let pid = null;
    let path = '';
    if (!this.record.id) {
      if (this.isRoot) {
        nodeLevel = 0;
      } else {
        pid = this.parent.id;
        let parentPath = this.parent.path;
        if (!parentPath) { //idéå·åéï¼ä»ä¸å°ä¸
          path = `,${this.parent.id},`;
        } else {
          path = `,${this.parent.id}${this.parent.path}`;
        }
        nodeLevel = this.parent.nodeLevel + 1;
      }
    }

    this.form = this.fb.group({
      pid: [pid, []],
      nodeLevel: [nodeLevel, []],
      path: [path, []],
      shortName: [null, [Validators.required]],
      fullName: [null, []],
      remark: [null, []],
      deptLegal: [null, []],
      telphone1: [null, []],
      telphone2: [null, []],
      address: [null, []],
      deptNature: [null, []],
      areaCode: [null, []],
      // typeShow: [null, [Validators.required]],
      typeTradec: [null, []],
      typeRI: [null, []],
      runStatus: [null, []],
      beginDate: [null, []],
      endDate: [null, []],
      rsvn: [null, []],
      benchmark: [null, [Validators.required]],
      status: [1, [Validators.required]],
      sortNum: [0, [Validators.required]],
    });
    if (!this.record.id) {
      return;
    }
    this.deptService.getById(this.record.id).subscribe((res:any) => {
      this.form.patchValue(res);
      // this.form.patchValue({code: res.code});
      this.i = res;
    });
  }

  compareNumStr(c1: any, c2: any): boolean {
    return c1 == c2;
  }

  codeAsyncValidator = (control: FormControl) =>
    Observable.create((observer: Observer<ValidationErrors>) => {
      if (!control.value) {
        observer.next(null);
        observer.complete();
        return;
      }
      this.deptService.checkCode({code: control.value, id: this.record.id}).subscribe((res:any)=> {
        if (res.valid === true) {
          observer.next(null);
        } else {
          observer.next({ error: true, duplicated: true });
        }
        observer.complete();
      });
    });

  submit() {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) return;
    if (!this.record.id) {
      //æ°å¢
      this.deptService.post(this.form.value).subscribe(res => {
        this.msgSrv.success('ä¿å­æå');
        this.modal.close(res);
      });
      return;
    }
    //ä¿®æ¹
    this.deptService.put(this.record.id, this.form.value).subscribe(res => {
      this.msgSrv.success('ä¿å­æå');
      this.modal.close(res);
    });
  }

  close() {
    this.modal.destroy();
  }
}
